import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import SimpleIconButton, { SIMPLE_ICON_BUTTON_VARIANTS } from "@/components/common/SimpleIconButton"
import { ICONS } from "@/constants"
import { BREAKPOINTS, colors } from "@/styles/themeSettings"

const Wrapper = styled.div`
	display: flex;

	//.second {
	//    translate: -1px;
	//}
`

const Box = styled.div`
	translate: 1px 0;
	user-select: none;
	border: 2px solid ${({ theme }) => theme.colors.richBlack};
	display: grid;
	place-items: center;
	padding: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	text-transform: uppercase;
	background: ${({ theme }) => theme.colors.whiteSmoke};
	color: ${({ theme }) => theme.colors.richBlack};
	font-weight: 600;
	max-width: ${getCssSizeValue(120, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: 0 ${getCssSizeValue(24)};
		max-width: unset;
	}
`

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media (max-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP] - 1}px) {
		.second {
			border-top: unset !important;
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		flex-direction: row;
		.second {
			translate: -1px 0;
		}
	}
`

export default function ArrowsNavigation({
	boxText,
	leftButtonClickHandler,
	rightButtonClickHandler,
	variant = SIMPLE_ICON_BUTTON_VARIANTS.LARGE,
}) {
	return (
		<Wrapper className="arrow-navigation">
			<Box className="typo-borna typo-borna-82 box">{boxText}</Box>
			<ButtonWrapper>
				<SimpleIconButton
					name={ICONS.CHEVRON}
					rotation={180}
					borderColor={colors.richBlack}
					pointer
					bgColor={colors.chilliRed}
					variant={variant}
					onClick={leftButtonClickHandler}
					wideBorder
				/>
				<SimpleIconButton
					name={ICONS.CHEVRON}
					className="second"
					borderColor={colors.richBlack}
					pointer
					bgColor={colors.chilliRed}
					variant={variant}
					onClick={rightButtonClickHandler}
					wideBorder
				/>
			</ButtonWrapper>
		</Wrapper>
	)
}
